import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Input, Segment, Table, Label } from 'semantic-ui-react';
import _ from 'lodash';
import TagSelector from '../../components/tags-selector';
import hasRestClient from '../../hocs/has-rest-client';
import { updateProfileTags } from './utils';

class ProfileTags extends Component {
  static propTypes = {
    details: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);

    const contentTags = _.get(props.details, 'contentTags', []);
    const brandTags = _.get(props.details, 'brandTags', []);

    this.state = {
      editing: false,
      contentTags,
      brandTags,
      contentTagsReadable: contentTags.join(', '),
      brandTagsReadable: brandTags.join(', '),
      tags: _.get(props, 'details.tags', []),
    };
  }

  setReadableTags = () => {
    const contentTagsSplit = _.split(this.state.contentTagsReadable, ',');
    const contentCleanValues = _.filter(contentTagsSplit, item => item && _.trim(item) !== '');
    const contentTagArray = _.map(contentCleanValues, tag => _.trim(tag));


    const brandTagsSplit = _.split(this.state.brandTagsReadable, ',');
    const brandCleanValues = _.filter(brandTagsSplit, item => item && _.trim(item) !== '');
    const brandTagArray = _.map(brandCleanValues, tag => _.trim(tag));

    this.setState({
      contentTags: contentTagArray,
      brandTags: brandTagArray,
    });
  }

  handleChange = (e, v) => {
    this.setState({
      [v.name]: v.value,
    });
  };

  updateTags = async () => {
    const { tags } = this.state;
    const { restClient, details: { id } } = this.props;
    const payload = _.map(tags, tag => ({
      id: tag.id,
      type: 'tags',
    }));
    await restClient.patch(`influencerDetails/${id}`, {
      data: {
        attributes: {
          tags: payload,
        },
      },
    });
    await this.props.onReloadDetails();
  }

  onTagSelected = (tagId, tags) => {
    const selected = _.find(tags, ['id', tagId]);
    const { tags: stateTags } = this.state;
    const newTags = _.concat(stateTags, [{
      id: selected.id,
      value: _.get(selected, 'attributes.value'),
    }]);
    this.setState({
      tags: newTags,
    });
  }

  onTagUnselected = tagId => {
    const { tags } = this.state;
    const newTags = _.reject(tags, ['id', tagId]);
    this.setState({
      tags: newTags,
    });
  }

  render() {
    const { editing, contentTags, brandTags, contentTagsReadable, brandTagsReadable, tags } = this.state;
    const influencerDetailsID = this.props.details.id;

    const selectedTagsIds = _.map(tags, 'id');

    return (
      <Segment padded>
        <h3>Tags</h3>
        { editing &&
          <span>
            <div className="spacer small" />
            <p>Enter tags, separated by commas</p>
          </span>
        }
        <Table basic="very">
          <Table.Body>
            <Table.Row>
              <Table.Cell collapsing>
                <p>Tags</p>
              </Table.Cell>
              <Table.Cell collapsing>
                {
                  editing ?
                    <TagSelector
                      onSelected={this.onTagSelected}
                      onUnselected={this.onTagUnselected}
                      selectedTags={selectedTagsIds}
                    /> :
                    <Label.Group>
                      {_.map(tags, tag => <Label>{tag.value}</Label>)}
                    </Label.Group>
                }
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell collapsing>
                <p>Content</p>
              </Table.Cell>
              <Table.Cell>
                { editing ?
                  <Input name="contentTagsReadable" value={contentTagsReadable} onChange={this.handleChange} placeholder="e.g. football, comedy..." fluid />
                  :
                  <div>
                    {contentTags && _.map(contentTags, t => t && <Label basic color="green" key={t}>{t}</Label>)}
                  </div>
                }
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell collapsing>
                <p>Brands</p>
              </Table.Cell>
              <Table.Cell>
                { editing ?
                  <Input name="brandTagsReadable" value={brandTagsReadable} onChange={this.handleChange} placeholder="e.g. Nike, L'oreal..." fluid />
                  :
                  <div>
                    {brandTags && _.map(brandTags, t => t && <Label basic color="blue" key={t}>{t}</Label>)}
                  </div>
                }
              </Table.Cell>
            </Table.Row>
            {editing
              ? <Table.Row>
                <Table.Cell>
                  <div className="spacer small" />
                  <Button size="medium" basic fluid onClick={() => this.setState({ editing: false })}>Cancel</Button>
                </Table.Cell>
                <Table.Cell>
                  <div className="spacer small" />
                  <Button
                    fluid
                    color="pink"
                    size="medium"
                    onClick={() => {
                      this.setState({ editing: false });
                      this.updateTags();
                      updateProfileTags(influencerDetailsID, contentTagsReadable, brandTagsReadable);
                      this.setReadableTags();
                    }}
                  >
                      Save Changes
                  </Button>
                </Table.Cell>
              </Table.Row>
              : <Table.Row>
                <Table.Cell colSpan={2}>
                  <div className="spacer small" />
                  <Button size="medium" basic fluid onClick={() => this.setState({ editing: true })}>
                    Edit Tags
                  </Button>
                </Table.Cell>
              </Table.Row>}
          </Table.Body>
        </Table>
      </Segment>
    );
  }
}

export default hasRestClient(ProfileTags);



/** WEBPACK FOOTER **
 ** ./src/containers/influencer-profile/profile-tags.js
 **/